import { useGetAgent } from './useGetAgent'

type GetAgencyProps = {
  agentId?: string
}

export function useGetAgency(props: GetAgencyProps) {
  const { isLoadingAgent, agentResponseIncluded, isFetchingAgent } = useGetAgent({ id: props.agentId })

  // Extract agency from the included data in the agent response
  const agency = agentResponseIncluded?.find(
    (resource) => resource.type === 'agency'
  ) || null

  return {
    isLoadingAgency: isLoadingAgent,
    isFetchingAgency: isFetchingAgent,
    agency,
  }
}
